import { useState, useEffect } from "react";
import { Table, Pagination, Space, Popconfirm, Spin, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import { get, del } from "../../services";
import { tokenExpired } from "../../utils/tokenExpired";

const Admintable = () => {
  const navigate = useNavigate();
  const [adminData, setAdmindata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const limit = 10;

  // Method for API call
  const getAllAdmins = (currentPage) => {
    setLoader(true);
    get(`/user/getAllUsers?page=${currentPage}&limit=${limit}`)
      .then((response) => {
        setAdmindata(response?.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        // to check token if token expired then logout user
        tokenExpired(err?.response?.data?.message, navigate);
      });
  };

  //  GET All Admins
  useEffect(() => {
    getAllAdmins(currentPage);
    // eslint-disable-next-line
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    // API call to delete selected record
    del(`/user/${data?._id}`)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = adminData?.users?.filter(
          (item) => item?._id !== data?._id
        );
        setAdmindata({ ...adminData, users: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  // Cancel
  const cancel = (e) => {
    console.log(e);
  };

  // Table Columns
  const columns = [
    {
      title: "Sr",
      dataIndex: "",
      key: "sr",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Role",
      key: "role",
      dataIndex: "role",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <div className="px-4">
            <EditOutlined
              className="cursor-pointer"
              onClick={() => {
                navigate(`/edit-admin/${data?._id}`);
              }}
            />
          </div>
          <div className="px-4">
            {data?._id === selectedRecord ? (
              <Spin />
            ) : (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => confirm(data)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteFilled className="cursor-pointer" />
              </Popconfirm>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="header4">
        <h3>Users</h3>
        <div className="events-button">
          <Link to="/add-admin">
            <button className="cursor-pointer add-event">Add New User</button>
          </Link>
        </div>
      </div>
      {/* table */}
      <Table
        columns={columns}
        dataSource={adminData?.users}
        loading={loader}
        pagination={false}
        scroll={{ x: 1023 }}
      />
      <Pagination
        defaultPageSize={currentPage}
        showSizeChanger={false}
        current={currentPage}
        pageSize={limit}
        total={adminData?.totalPages}
        onChange={(e) => {
          setCurrentPage(e);
          getAllAdmins(e);
        }}
        className="pagination"
      />
    </div>
  );
};
export default Admintable;
